import { BackgroundEditor } from "./fields";

// Sections d'accueil personnalisables (id doit correspondre au <SectionBg id> côté site)
const SECTIONS = [
  { id: "stats", label: "Statistiques" },
  { id: "mission", label: "Mission" },
  { id: "association", label: "L'Association" },
  { id: "activities", label: "Nos activités" },
  { id: "realisations", label: "Réalisations" },
  { id: "festival", label: "Festival" },
  { id: "team", label: "Équipe" },
  { id: "testimonials", label: "Témoignages" },
  { id: "contact", label: "Contact" },
];

export const AdminSectionBackgrounds = ({ value = {}, onChange }) => {
  const map = value || {};
  const setOne = (id, cfg) => onChange({ ...map, [id]: cfg });
  return (
    <div className="space-y-5">
      <div className="rounded-lg border border-electric/20 bg-[#0a0a0a] p-4 text-sm text-secondary2">
        Personnalisez l'arrière-plan de chaque section d'accueil : couleur, dégradé, image ou vidéo, avec un voile d'assombrissement pour garder le texte lisible. « Aucun » conserve le design cinématographique par défaut.
      </div>
      {SECTIONS.map((s) => (
        <div key={s.id} className="rounded-lg border border-white/10 bg-[#0a0a0a] p-4 space-y-3" data-testid={`admin-bg-${s.id}`}>
          <div className="text-[11px] tracking-[0.25em] uppercase text-electric">{s.label}</div>
          <BackgroundEditor value={map[s.id]} onChange={(cfg) => setOne(s.id, cfg)} testid={`admin-bg-editor-${s.id}`} />
        </div>
      ))}
    </div>
  );
};
